function init() {
  // Listen for changes done in the Theme Editor
  document.addEventListener('shopify:section:load', event => {
    if (event.detail.sectionId === 'product-recommendations') {
      productRecommendations();
    }
  });

  productRecommendations();
}

function productRecommendations() {
  const container = document.querySelector('.js-product-recommendations');
  if (!container) {
    return;
  }

  const { baseUrl, productId, sectionId, limit } = container.dataset;
  const recommendationsSectionUrl = `${baseUrl}?section_id=${sectionId}&product_id=${productId}&limit=${limit}`;

  fetch(recommendationsSectionUrl)
    .then(res => res.text())
    .then(section => {
      container.innerHTML = section;
    });
}

init();
